import React from "react";
import { useTranslation } from "react-i18next";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { useStartupParamsStore } from "@/store/startupParams";
import { I18nString } from "@/utils/i18n-types";
import cls from "./styles.module.scss";

const DiscussIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M18.666 6.66699C22.4369 6.66699 24.3226 6.66651 25.4941 7.83789C26.6657 9.00946 26.666 10.8958 26.666 14.667C26.666 18.438 26.6657 20.3236 25.4941 21.4951C24.3226 22.6667 22.437 22.667 18.666 22.667H10.8712C10.769 22.667 10.7179 22.667 10.6719 22.686C10.626 22.7051 10.5899 22.7412 10.5176 22.8135L7.03906 26.293C6.40918 26.9225 5.33242 26.4764 5.33203 25.5859V14.667C5.33203 10.8958 5.33233 9.00946 6.50391 7.83789C7.67546 6.66651 9.56119 6.66699 13.332 6.66699H18.666Z"
      fill="black"
    />
    <path
      d="M11.334 12.6665L20.6673 12.6665"
      stroke="url(#discussIconLine1)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.334 16.6665H18.0007"
      stroke="url(#discussIconLine2)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="discussIconLine1"
        x1="16.0007"
        y1="12.6665"
        x2="16.0007"
        y2="13.6665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECF08" />
        <stop offset="1" stopColor="#F8A004" />
      </linearGradient>
      <linearGradient
        id="discussIconLine2"
        x1="14.6673"
        y1="16.6665"
        x2="14.6673"
        y2="17.6665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECF08" />
        <stop offset="1" stopColor="#F8A004" />
      </linearGradient>
    </defs>
  </svg>
);

const ChevronRightIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.5 4.1665L12.5 9.99984L7.5 15.8332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PARK_BUTTON_CONFIG: Record<
  string,
  { labelKey: I18nString; fallbackLink: string }
> = {
  delivery: {
    labelKey: "goals.common.deliveryPark",
    fallbackLink: "https://t.me/BogatiyKurier_chat",
  },
  eats: {
    labelKey: "goals.common.edaPark",
    fallbackLink: "https://t.me/EdaBkchat",
  },
  taxi: {
    labelKey: "goals.common.taxiPark",
    fallbackLink: "https://t.me/BogatiyTaksist_chat",
  },
};

const DEFAULT_PARK_BUTTON_CONFIG = PARK_BUTTON_CONFIG.delivery;

export const GoToParkButton = () => {
  const { t } = useTranslation();
  const initData = useGoalsStore((state) => state.initData);
  const serviceType = useStartupParamsStore((state) => state.serviceType);
  const config = serviceType
    ? PARK_BUTTON_CONFIG[serviceType] ?? DEFAULT_PARK_BUTTON_CONFIG
    : DEFAULT_PARK_BUTTON_CONFIG;
  const link = initData?.program.invite_chat_url ?? config.fallbackLink;

  return (
    <button
      className={cls.button}
      type="button"
      onClick={() => window.open(link)}
    >
      <DiscussIcon />
      <span className={cls.label}>{t(config.labelKey)}</span>
      <ChevronRightIcon />
    </button>
  );
};
